// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"588fd9f9","227":"9bb581b4","239":"6ff4b34c","389":"8daac311","453":"28af1e53","455":"9c1cf240","569":"7a534b63","625":"58bf8c6d","635":"098826dc","892":"5fd4ac40","977":"def3882a"}[chunkId] + ".chunk.js";
};